import { Breadcrumb, type BreadcrumbItem } from '@7f-ui/components/breadcrumb/breadcrumb'

type Props = {
  links?: BreadcrumbItem[]
  placement?: 'top' | 'bottom'
}

export function DestinationBreadcrumbs({ links = [], placement }: Props) {
  return (
    <Breadcrumb
      links={[
        {
          label: 'Alle Reiseziele',
          url: '/reiseziele/',
        },
        ...links,
      ]}
      placement={placement}
      useFluidContainer={placement !== 'bottom'}
    />
  )
}
